import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (
      err.response?.status === 401 &&
      err.config?.url !== "/auth/me" &&
      !window.location.pathname.startsWith("/login")
    ) {
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const register = async (payload) => (await api.post("/auth/register", payload)).data;
export const login = async (payload) => (await api.post("/auth/login", payload)).data;
export const logoutUser = async () => (await api.post("/auth/logout")).data;
export const fetchMe = async () => (await api.get("/auth/me")).data;
export const exchangeGoogleSession = async (session_id) => (await api.post("/auth/session", { session_id })).data;

export const addVideo = async (url) => (await api.post("/videos", { url })).data;
export const listVideos = async () => (await api.get("/videos")).data;
export const getVideo = async (id) => (await api.get(`/videos/${id}`)).data;
export const deleteVideo = async (id) => (await api.delete(`/videos/${id}`)).data;
export const bulkDeleteVideos = async (ids) => (await api.post("/videos/bulk-delete", { video_ids: ids })).data;
export const rateVideo = async (id, rating) => (await api.patch(`/videos/${id}/rating`, { rating })).data;

export const updateProfile = async (payload) => (await api.patch("/auth/profile", payload)).data;
export const forgotPassword = async (email) => (await api.post("/auth/forgot-password", { email })).data;
export const resetPassword = async (payload) => (await api.post("/auth/reset-password", payload)).data;

export const listFolders = async () => (await api.get("/folders")).data;
export const createFolder = async (name) => (await api.post("/folders", { name })).data;
export const deleteFolder = async (id) => (await api.delete(`/folders/${id}`)).data;
export const getFolder = async (id) => (await api.get(`/folders/${id}`)).data;
export const saveToFolder = async (folderId, video_id) => (await api.post(`/folders/${folderId}/videos`, { video_id })).data;
export const removeFromFolder = async (folderId, videoId) => (await api.delete(`/folders/${folderId}/videos/${videoId}`)).data;

export const importYouTube = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return (await api.post("/import/youtube", fd)).data;
};
export const listImports = async () => (await api.get("/import/youtube")).data;
export const clearImports = async () => (await api.delete("/import/youtube")).data;

export const adminUsers = async () => (await api.get("/admin/users")).data;
export const lockUser = async (email) => (await api.post("/admin/users/lock", { email })).data;
export const unlockUser = async (email) => (await api.post("/admin/users/unlock", { email })).data;
export const deleteUser = async (email) => (await api.post("/admin/users/delete", { email })).data;
export const adminActivity = async (email) => (await api.get(`/admin/users/activity/${encodeURIComponent(email)}`)).data;
